export default __webpack_public_path__ + "static/media/thankYou.eda610aa.png";